import HeroTitleComponent from './templates/HeroTitleComponent';
import HeroBoxComponent from './templates/HeroBoxComponent';
import MgpFormRadio from '../../../elements/MgpFormRadio/MgpFormRadio';
import { accessJsonAttr } from '../../../utils/utils';

type REGuarantyTableInfoComponentProps = {
    handleSetHasReduction: (response: boolean) => void;
    register: any;
    errors: any
};
  
  
  
export default function REGuarantyTableInfoComponent({
    handleSetHasReduction,
    register,
    errors
}: REGuarantyTableInfoComponentProps) {

    
      
    return (
        <form className="">
            <div className='info-table-hero-content'>
                <HeroTitleComponent 
                    text="QUI PEUT EN BÉNÉFICIER EN 2026&nbsp;?"
                    icon="icon-personne"
                    isIcon={true}
                />
            </div>
           
            <div className='info-table-content'>
                <div> 
                    <div className="hero-text-lign">
                        <p className="hero-text-bulle"></p>
                        <p className="hero-text-info">Ce fonds s'adresse aux agents retraités adhérents au contrat socle PSC, <strong>sous conditions d'éligibilité de ressources.</strong></p>
                    </div>
                  
                    <div>
                        <HeroBoxComponent 
                            text='La minoration ne concerne pas les cotations relatives aux ayants droit et aux options'
                            backgroundColor='fushia'
                            icon='icon-danger'
                            iconBackgroundColor='bleu'
                            position='left'
                        />
                    </div>    
                </div>
                <div className='hide-in-mobile'>
                     <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/Cotisations.png"}></img>
                </div>
            </div>

            <div className='info-table mt-lg'>
                <table>
                    <tbody>
                        <tr>
                            <th></th>
                            <th colSpan={2} className='bg-bleu blanc'>
                                VOTRE DERNIER REVENU FISCAL DE RÉFÉRENCE EST&nbsp;:
                            </th>
                        </tr>
                        <tr>
                            <th className='bg-fushia-20 lign-title fushia'>
                                <div className=''>
                                    <i className='icon-personne fz-sm'></i>
                                </div>
                                <p className='text'>Agent retraité seul</p>
                            </th>
                            <th className='bg-bleu-medium-20 bleu text'>Inférieur ou égal à 17 000 €</th>
                            <th className='bg-bleu-medium-20 bleu text'>Entre 17 001 € et 20 100 €</th>
                        </tr>
                        <tr>
                            <th className='bg-fushia-20 lign-title fushia '>
                                <div>
                                    <i className='icon-personne fz-sm'></i>
                                    <i className='icon-personne fz-sm'></i>
                                </div>
                                <p className='text'>Agent retraité et conjoint</p>
                            </th>
                            <th className='bg-bleu-medium-20 bleu text'>Inférieur ou égal à 25 500 €</th>
                            <th className='bg-bleu-medium-20 bleu text'>Entre 25 501 € et 30 150 €</th>
                        </tr>
                        <tr>
                            <th className='bg-fushia-20 lign-title fushia'>
                                <div>
                                    <i className='icon-personne fz-sm'></i>
                                    <i className='icon-personne fz-xs icon-child'></i>
                                </div>
                                <p className='text'>Agent retraité et 1 enfant rattaché</p>
                            </th>
                            <th className='bg-bleu-medium-20 bleu text'>Inférieur ou égal à 22 100 €</th>
                            <th className='bg-bleu-medium-20 bleu text'>Entre 22 101 € et 26 130 €</th>
                        </tr>
                        <tr>
                            <th className='bg-fushia-20 lign-title fushia'>
                                <div>
                                    <i className='icon-personne fz-sm'></i>
                                    <i className='icon-personne fz-sm'></i>
                                    <i className='icon-personne fz-xs icon-child'></i>
                                </div>
                                <p className='text'>Agent retraité, conjoint et 1 enfant rattaché</p>
                            </th>
                            <th className='bg-bleu-medium-20 bleu text'>Inférieur ou égal à 30 600 €</th>
                            <th className='bg-bleu-medium-20 bleu text'>Entre 30 601 € et 36 180 €</th>
                        </tr>
                    
                        <tr>
                            <th>
                                
                            </th>
                            <th className='bg-bleu blanc'>
                                <div className='info-table-pie-column'>
                                    <div className='info-table-pie info-table-pie-large hide-in-mobile'></div>
                                    <div className='text'>
                                        <p>Prise en charge de la cotisation à</p>
                                        <p className='fz-lg fw-bold'>22%</p>
                                    </div>
                                </div>
                            </th>
                            <th className='bg-bleu blanc'>
                                <div className='info-table-pie-column'>
                                    <div className='info-table-pie info-table-pie-small hide-in-mobile'></div>
                                    <div className='text'>
                                        <p >Prise en charge de la cotisation à</p>
                                        <p className='fz-lg fw-bold'>12%</p>
                                    </div>
                                </div>
                                
                            </th>
                        </tr>
                    </tbody>
                </table>

            </div>

            <div className="hero-text-lign mt-md">
                <p className="hero-text-bulle"></p>
                <p className="hero-text-info">Si le revenu fiscal de référence de l'agent retraité est <strong>supérieur à celui du barème</strong>, il ne bénéficie pas d'une minoration de ses cotisations.</p>
            </div>

            <div className='mt-lg'>
                <div className='form-check-label fw-medium text'>
                    Afin d'étudier mon éligibilité à la minoration de cotisations, je vous adresse mon dernier avis d'imposition.
                </div>

                <div className='form-row va-center jc-start' style={{width: "max-content"}} >     
                    <MgpFormRadio 
                        id='hasReduction'  
                        value='true' 
                        label='Oui' 
                        register={register} 
                        errors={errors} 
                        onClick={()=>{handleSetHasReduction(true)}}
                    />
                    <MgpFormRadio 
                        id='hasReduction' 
                        value='false' 
                        label='Non' 
                        register={register} 
                        errors={errors}  
                        onClick={()=>{handleSetHasReduction(false)}}
                    />
                </div>   
            
            </div>
        </form>   

    );
  }